<div class="collapsibleTitle pageTitle">
  <div class="collapseButtonContainer pb-0">
    <button
      type="button"
      *ngIf="commentsHistory.opened"
      class="submitSearchButton"
      (click)="loadCommentsHistory()"
    >
      <em class="fas fa-angle-up"></em>
    </button>
    <button
      type="button"
      *ngIf="!commentsHistory.opened"
      class="submitSearchButton"
      (click)="loadCommentsHistory()"
    >
      <em class="fas fa-angle-down"></em>
    </button>
    <div class="pageTitle collapsibleTitle">
      <div class="title halfTitle">Histórico de comentarios</div>
    </div>
  </div>
</div>

<div *ngIf="commentsHistory.opened && commentsHistory.loaded">
  <table *ngIf="commentsHistory.data.length > 0" class="table table-striped">
    <caption style="display: none">
      Texto prueba
    </caption>

    <tbody>
      <tr
        *ngFor="let item of commentsHistory.data"
        [innerHTML]="item.hcComentario"
      >
        <th></th>
      </tr>
    </tbody>
  </table>
  <div *ngIf="commentsHistory.data.length == 0">
    <br />
    <p>{{ "messages.notExistComments" | translate }}</p>
  </div>
</div>
